import styled from 'styled-components';

import { BodyStandardRegular, Colour, MinBreakpointV2 } from '@xemplo/style-constants';

export const PromptBody = styled.div`
  display: flex;
  padding: 0px 32px;

  flex-direction: column;
  align-items: center;
  text-align: center;
  ${BodyStandardRegular};
  color: ${Colour.Gray[600]};

  &.system-prompt {
    color: ${Colour.Light[80]};
  }
  &.extended {
    @media ${MinBreakpointV2.medium} {
      align-items: start;
      text-align: left;
    }
  }
`;
